// Store functionality
import actions from './actions'

export default {
  actions: actions,
}
